var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.463,
    height: 16.463,
    viewBox: "0 0 16.463 16.463",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.25 0.247)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.768,14.831l-4.539-4.539a6.331,6.331,0,1,0-.94.94l4.539,4.539a.665.665,0,1,0,.94-.94ZM6.319,11.31a4.988,4.988,0,1,1,4.988-4.988A4.994,4.994,0,0,1,6.319,11.31Z",
    transform: "translate(0 -0.003)",
    fill: "#dce2ea",
    stroke: "#dce2ea",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.69989d61eaa2619ca8958c56868f69f0.svg";
export { ForwardRef as ReactComponent };